// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {ProfileState} from 'redux/uiState/profile/ProfileState';

import {
  createReducerUsingActionHandlers,
  PURE,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {
  SET_DATA_TAKEN_AFTER_LOGIN,
  SET_PROFILE_DATA_LOADED,
} from 'redux/uiState/profile/actions';
import {profileState} from 'redux/uiState/UiState';

const initState: ProfileState = {
  dataTakenAfterLogin: true,
  profileDataLoaded: false,
};

const actionCreators: ActionHandlers<ProfileState> = {
  [PURE(SET_DATA_TAKEN_AFTER_LOGIN)]: (state: ProfileState, {value}) => ({
    ...state,
    dataTakenAfterLogin: value,
  }),
  [PURE(SET_PROFILE_DATA_LOADED)]: (state: ProfileState, {value}) => ({
    ...state,
    profileDataLoaded: value,
  }),
};

export const profileReducer: Reducer<ProfileState> = // $FlowIgnore
  createReducerUsingActionHandlers<ProfileState>(initState, actionCreators);

export const getDataTakenAfterLogin: Selector<boolean> = createSelector(
  profileState,
  (state: ProfileState) => state.dataTakenAfterLogin
);

export const getProfileDataLoaded: Selector<boolean> = createSelector(
  profileState,
  (state: ProfileState) => state.profileDataLoaded
);
